import { ReactNode } from 'react';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { ROUTES } from '@/constants';
import { TeamPage } from '@/pages/team/TeamPage';
import { RootRedirect } from '@/components/auth/RootRedirect';
import { ManagerPage } from '@/pages/manager/ManagerDashboard';
import { TeamView } from '@/pages/manager/TeamView';
import { PerformanceView } from '@/pages/manager/PerformanceView';
import { AlertsDashboard } from '@/pages/manager/AlertsDashboard';
import { QualityMetricsView } from '@/pages/manager/QualityMetricsView';
import { CallHistoryManagerView } from '@/pages/manager/CallHistoryManagerView';
import { MyProfilePage } from '@/pages/agent/MyProfilePage';
export interface RouteConfig {
  path: string; //(typeof ROUTES)[keyof typeof ROUTES];
  element: ReactNode;
  isProtected: boolean;
  children?: {
    path?: string;
    index?: boolean;
    element: ReactNode;
  }[];
}

export const routes: RouteConfig[] = [
  {
    path: ROUTES.HOME,
    element: <RootRedirect />,
    isProtected: false,
  },
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
    isProtected: false,
  },
  {
    path: ROUTES.DASHBOARD,
    element: <DashboardPage />,
    isProtected: true,
  },
  {
    path: ROUTES.TEAM,
    element: <TeamPage />,
    isProtected: true,
  },
  {
    path: ROUTES.MANAGER.ROOT,
    element: <ManagerPage />,
    isProtected: true,
    children: [
      {
        index: true,
        element: <TeamView />, // default view
      },
      {
        path: ROUTES.MANAGER.TEAM,
        element: <TeamView />,
      },
      {
        path: ROUTES.MANAGER.PERFORMANCE,
        element: <PerformanceView />,
      },
      {
        path: ROUTES.MANAGER.QUALITY_METRICS,
        element: <QualityMetricsView />,
      },
      {
        path: ROUTES.MANAGER.CALL_HISTORY,
        element: <CallHistoryManagerView />,
      },
    ],
  },
  {
    path: `${ROUTES.MANAGER.ROOT}/${ROUTES.MANAGER.ALERTS}`,
    element: <AlertsDashboard />,
    isProtected: true,
  },
  {
    path: ROUTES.PROFILE,
    element: <MyProfilePage />,
    isProtected: true,
  },
];
